(() => {
  if (window.__cyseekinCartDrawerProtectionV1) return;
  window.__cyseekinCartDrawerProtectionV1 = true;

  const rootSelector = '#CartDrawer, main-cart';
  const infoSelector = '[data-cy-protection-info]';
  let drawerObserver;
  let observedDrawer;
  let frame;
  let protectionSelected = false;
  let forwardingCheckout = false;

  const ownText = (element) => Array.from(element?.childNodes || [])
    .filter((node) => node.nodeType === Node.TEXT_NODE)
    .map((node) => node.textContent.trim())
    .filter(Boolean)
    .join(' ');

  const schedule = () => {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      enhance();
    });
  };

  const updateSwitch = (drawer) => {
    const button = drawer.querySelector('[data-cy-protection-switch]');
    if (!button) return;
    button.setAttribute('aria-checked', String(protectionSelected));
    drawer.setAttribute('data-cy-protection-selected', String(protectionSelected));
  };

  const createControls = (drawer, host, tip) => {
    const title = host.querySelector('.xcotton_bd_title');
    const price = title?.querySelector('.xcotton_price');
    if (!title || !price) return;

    let button = title.querySelector(infoSelector);
    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'cy-drawer-protection__info';
      button.setAttribute('data-cy-protection-info', '');
      button.innerHTML = `
        <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">
          <circle cx="10" cy="10" r="8.25"></circle>
          <path d="M10 8.25v5"></path>
          <circle cx="10" cy="5.75" r=".75" class="cy-drawer-protection__info-dot"></circle>
        </svg>`;
      price.before(button);
    }

    const titleText = ownText(title) || 'Shipping Protection';
    const detailsText = tip.textContent.trim() || 'Details';
    button.setAttribute('aria-label', `${detailsText}: ${titleText}`);

    let protectionSwitch = title.querySelector('[data-cy-protection-switch]');
    if (!protectionSwitch) {
      protectionSwitch = document.createElement('button');
      protectionSwitch.type = 'button';
      protectionSwitch.className = 'cy-drawer-protection__switch';
      protectionSwitch.setAttribute('data-cy-protection-switch', '');
      protectionSwitch.setAttribute('role', 'switch');
      protectionSwitch.innerHTML = '<span class="cy-drawer-protection__switch-thumb" aria-hidden="true"></span>';
      price.after(protectionSwitch);
    }
    protectionSwitch.setAttribute('aria-label', `${titleText}: ${price.textContent.trim()}`);
    updateSwitch(drawer);
  };

  const setCheckoutLabel = (drawer, button) => {
    const label = drawer.dataset.cyCheckoutLabel?.trim();
    if (!label || button.textContent.trim() === label) return;

    const text = button.querySelector('.btn-text');
    if (text) text.textContent = label;
    else button.textContent = label;
    button.setAttribute('aria-label', label);
  };

  const enhance = () => {
    const drawer = document.querySelector('main-cart') || document.querySelector('#CartDrawer');
    if (!drawer) return;

    if (drawer !== observedDrawer) {
      drawerObserver?.disconnect();
      observedDrawer = drawer;
      drawerObserver = new MutationObserver(schedule);
      drawerObserver.observe(drawer, {
        attributes: true,
        attributeFilter: ['style'],
        childList: true,
        subtree: true,
      });
    }

    const host = drawer.querySelector('#xcottonWrapper');
    const tip = host?.querySelector('#xcotton-tip');
    const checkoutWithout = drawer.querySelector('[data-xmh-checkout-without="true"]');
    const checkoutWith = drawer.querySelector('[data-xmh-checkout="true"]');

    if (!host || !tip || !checkoutWithout || !checkoutWith) {
      if (drawer.querySelector('.drawer__footer')?.classList.contains('hidden')) {
        protectionSelected = false;
      }
      drawer.removeAttribute('data-cy-protection-ready');
      drawer.removeAttribute('data-cy-protection-selected');
      return;
    }

    createControls(drawer, host, tip);
    setCheckoutLabel(drawer, checkoutWithout);
    checkoutWith.classList.add('cy-drawer-protection__checkout-with');
    if (checkoutWith.style.getPropertyValue('display') !== 'none'
      || checkoutWith.style.getPropertyPriority('display') !== 'important') {
      checkoutWith.style.setProperty('display', 'none', 'important');
    }
    checkoutWith.setAttribute('aria-hidden', 'true');
    checkoutWith.setAttribute('tabindex', '-1');
    drawer.setAttribute('data-cy-protection-ready', 'true');
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.(infoSelector);
    if (button?.closest(rootSelector)) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const tip = button.closest('#xcottonWrapper')?.querySelector('#xcotton-tip');
      tip?.click();
      return;
    }

    const protectionSwitch = event.target.closest?.('[data-cy-protection-switch]');
    if (protectionSwitch?.closest(rootSelector)) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      protectionSelected = !protectionSelected;
      updateSwitch(protectionSwitch.closest(rootSelector));
      return;
    }

    const checkoutWithout = event.target.closest?.('[data-xmh-checkout-without="true"]');
    if (!checkoutWithout?.closest(rootSelector) || !protectionSelected || forwardingCheckout) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const checkoutWith = checkoutWithout.closest(rootSelector).querySelector('[data-xmh-checkout="true"]');
    if (!checkoutWith) return;
    forwardingCheckout = true;
    checkoutWith.click();
    setTimeout(() => {
      forwardingCheckout = false;
    });
  }, true);

  window.addEventListener('click', (event) => {
    if (!event.target.closest?.('#xcottonsActionBtn')) return;
    protectionSelected = true;
    schedule();
  }, true);

  document.addEventListener('shopify:section:load', schedule);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }
})();
